import React from 'react';
import { styled } from 'styled-components';
import useEmblaCarousel from 'embla-carousel-react';
import { Chip, tk, horizontalGap, verticalGap, useToken } from '@sunwebgroup/ui-components';
import { useUserReviews } from '@/scopes/products/user-reviews/hooks';
import { getPartyCompositionType } from '../utils';
import { useIntl } from 'react-intl';
import { createUserReviewsEvent } from '../../../../user-reviews/infrastructure/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

const Slider = styled.div`
  overflow: hidden;
  margin-bottom: ${tk('spacing_md')};
  width: calc(100% + ${tk('spacing_lg')} * 2);
  margin-left: -${tk('spacing_lg')};

  @media ${tk('mq_desktop_md')} {
    width: 100%;
    margin-left: unset;
  }
`;

const SliderContainer = styled.div`
  display: flex;
  padding: ${tk('spacing_2xs')};

  &:first-child {
    margin-left: ${tk('spacing_md')};
  }

  ${horizontalGap('spacing_xs')}

  @media ${tk('mq_desktop_md')} {
    display: block;
    ${verticalGap('spacing_xs')}

    &:first-child {
      margin-left: unset;
    }
  }
`;

export function PartyCompositionFilter() {
  const intl = useIntl();
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    breakpoints: {
      [`${useToken<string>('mq_desktop_md')}`]: { active: false },
    },
  });
  const { sendEvent } = useAnalytics();

  const { partyCompositionGroups, partyCompositionGroupId, setPartyCompositionGroupId } = useUserReviews();
  const reviewsAmount = partyCompositionGroups.reduce((result, group) => result + group.amount, 0);

  const handleClickPartyCompositionGroup = (groupId: string) => {
    setPartyCompositionGroupId(groupId);
    sendEvent(
      createUserReviewsEvent({
        description: 'show reviews of party composition',
        element: 'Chip',
        result: intl.formatMessage({ id: `reviews_party_composition_${getPartyCompositionType(groupId)}_label` }),
      })
    );
  };

  return (
    <Slider ref={emblaRef}>
      <SliderContainer>
        <Chip onClick={() => handleClickPartyCompositionGroup('')} active={!partyCompositionGroupId}>
          {intl.formatMessage({ id: 'reviews_party_composition_all_label' })}{' '}
          {Boolean(reviewsAmount) && `(${reviewsAmount})`}
        </Chip>
        {partyCompositionGroups?.map((group) => (
          <Chip
            key={group.groupId}
            onClick={() => handleClickPartyCompositionGroup(group.groupId)}
            active={partyCompositionGroupId === group.groupId}
          >
            {intl.formatMessage({ id: `reviews_party_composition_${getPartyCompositionType(group.groupId)}_label` })} (
            {group.amount})
          </Chip>
        ))}
      </SliderContainer>
    </Slider>
  );
}
